import { contrastingForegroundForHsl } from './color-contrast'
import type { EditableThemeTokensByVariant } from './theme-config'

function randomHue() {
  return Math.floor(Math.random() * 360)
}

function normalizedHue(hue: number) {
  return ((hue % 360) + 360) % 360
}

function hsl(hue: number, saturation: number, lightness: number) {
  return `hsl(${normalizedHue(hue)} ${saturation}% ${lightness}%)`
}

export function generateRandomThemeTokens(): EditableThemeTokensByVariant {
  const baseHue = randomHue()
  const accentHue = baseHue + 36
  const surfaceHue = baseHue - 18
  const lightPrimary = hsl(baseHue, 62, 56)
  const lightPrimaryForeground = contrastingForegroundForHsl(baseHue, 62, 56)
  const darkPrimary = hsl(baseHue, 70, 68)
  const darkPrimaryForeground = contrastingForegroundForHsl(baseHue, 70, 68)

  return {
    light: {
      background: hsl(surfaceHue, 40, 98),
      foreground: hsl(baseHue + 160, 26, 16),
      card: hsl(surfaceHue, 36, 99),
      'card-foreground': hsl(baseHue + 160, 26, 16),
      primary: lightPrimary,
      'primary-foreground': lightPrimaryForeground,
      accent: hsl(accentHue, 70, 90),
      'accent-foreground': hsl(baseHue + 165, 24, 18),
      border: hsl(surfaceHue, 22, 84),
      ring: hsl(baseHue, 55, 62),
      sidebar: hsl(surfaceHue, 34, 97),
      'sidebar-foreground': hsl(baseHue + 160, 26, 16),
      'sidebar-primary': lightPrimary,
      'sidebar-primary-foreground': lightPrimaryForeground,
      'sidebar-accent': hsl(accentHue, 64, 92),
      'sidebar-accent-foreground': hsl(baseHue + 165, 24, 18),
    },
    dark: {
      background: hsl(baseHue + 170, 28, 12),
      foreground: hsl(surfaceHue, 32, 95),
      card: hsl(baseHue + 168, 24, 16),
      'card-foreground': hsl(surfaceHue, 32, 95),
      primary: darkPrimary,
      'primary-foreground': darkPrimaryForeground,
      accent: hsl(accentHue, 42, 34),
      'accent-foreground': hsl(surfaceHue, 32, 95),
      border: hsl(baseHue + 175, 18, 28),
      ring: hsl(baseHue, 66, 72),
      sidebar: hsl(baseHue + 170, 26, 15),
      'sidebar-foreground': hsl(surfaceHue, 32, 95),
      'sidebar-primary': darkPrimary,
      'sidebar-primary-foreground': darkPrimaryForeground,
      'sidebar-accent': hsl(accentHue, 38, 30),
      'sidebar-accent-foreground': hsl(surfaceHue, 32, 95),
    },
  }
}
